import api from './api';

export const CUSTOMER_BELL_PAGE_SIZE = 5;
export const CUSTOMER_NOTIFICATIONS_PAGE_SIZE = 20;

const normalizePaginated = (response) => ({
  data: response.data?.data || [],
  pageIndex: response.data?.pageIndex ?? 0,
  itemsPerPage: response.data?.itemsPerPage ?? CUSTOMER_NOTIFICATIONS_PAGE_SIZE,
  totalItems: response.data?.totalItems ?? 0,
});

export const getCustomerInAppNotifications = async (
  storeId,
  { pageIndex = 0, itemsPerPage = CUSTOMER_NOTIFICATIONS_PAGE_SIZE } = {},
) => {
  const response = await api.get('/customer-in-app-notifications', {
    params: { pageIndex, itemsPerPage },
    _authContext: 'customer',
    _storeId: storeId,
  });
  return normalizePaginated(response);
};

const toUnreadCount = (value) => {
  const count = Number(value);
  return Number.isInteger(count) && count >= 0 ? count : 0;
};

export const getCustomerInAppNotificationUnreadCount = async (storeId) => {
  const response = await api.get('/customer-in-app-notifications/unread-count', {
    _authContext: 'customer',
    _storeId: storeId,
  });
  const data = response.data;
  if (typeof data === 'number') {
    return toUnreadCount(data);
  }
  return toUnreadCount(data?.count);
};

export const markCustomerInAppNotificationRead = async (notificationId, storeId) => {
  await api.post(`/customer-in-app-notifications/${notificationId}/read`, null, {
    _authContext: 'customer',
    _storeId: storeId,
  });
};

export const markAllCustomerInAppNotificationsRead = async (storeId) => {
  await api.post('/customer-in-app-notifications/read-all', null, {
    _authContext: 'customer',
    _storeId: storeId,
  });
};

export const markCustomerChatNotificationsRead = async (conversationId, storeId) => {
  const response = await api.post(
    `/customer-in-app-notifications/conversations/${conversationId}/read`,
    null,
    {
      _authContext: 'customer',
      _storeId: storeId,
    },
  );
  const data = response.data;
  if (typeof data === 'number') {
    return toUnreadCount(data);
  }
  return toUnreadCount(data?.count);
};
